import { Dispatch, SetStateAction, useState } from 'react';

import { ImportType } from 'corporate/enums';
import { ModalStep } from 'partsOld/enums';

import ImportView from './ImportView';

const defaultOptions = {
  mergeDuplicates: 1,
  headerRowIndex: 0,
};

const Import = () => {
  const [importType, setImportType] = useState();
  const [step, setStep] = useState();
  const [data, setData] = useState({ ...defaultOptions });

  const onSubmit = (obj) => {
    setData({ ...data, ...obj });
  };

  return (
    <ImportView
      onSubmit={onSubmit}
      step={step}
      setStep={setStep as Dispatch<SetStateAction<ModalStep>>}
      data={data}
      setImportType={setImportType as Dispatch<SetStateAction<ImportType>>}
      importType={importType}
    />
  );
};

export default Import;
